import { useState, useCallback } from 'react';

const useFormNavigation = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [yesNoAnswer, setYesNoAnswer] = useState(null);
  const [invoiceAnswer, setInvoiceAnswer] = useState(null);

  const handleNext = useCallback(() => {
    console.log('handleNext called, current page:', currentPage);
    setCurrentPage(prevPage => {
      const nextPage = prevPage + 1;
      console.log('Moving to page:', nextPage);
      return nextPage;
    });
  }, [currentPage]);

  const handlePrevious = useCallback(() => {
    console.log('handlePrevious called, current page:', currentPage);
    setCurrentPage(prevPage => {
      const nextPage = prevPage - 1;
      console.log('Moving to page:', nextPage);
      return nextPage;
    });
  }, [currentPage]);

  return {
    currentPage,
    setCurrentPage,
    handleNext,
    handlePrevious,
    yesNoAnswer,
    setYesNoAnswer,
    invoiceAnswer,
    setInvoiceAnswer
  };
};

export default useFormNavigation;